import axios from "axios";
import MAuth from "./MAuth";
import MURL from "./MURL";

export default class MRequest
{
	constructor(method, url, data, config)
	{
		this.method = method;
		this.url = url;
		this.data = data;
		this.config = config;
	}

	getPromise()
	{
		let method = this.method;
		let url = this.url;
		let data = this.data;
		let config = this.config;

		if (method.toUpperCase() == "GET") {
			url = (new MURL(url, data)).toString();
			data = null;
		}

		if (!config) {
			config = {};
		}

		config.method = method;
		config.url = url;
		config.data = data;
		config.headers = {
			...config.headers,
			...MAuth.getAccessTokenHeaders(),
		};

		return axios(config);
	}

	static get(url, data, config)
	{
		return (new this("GET", url, data, config)).getPromise();
	}

	static post(url, data, config)
	{
		return (new this("POST", url, data, config)).getPromise();
	}

	static delete(url, data, config)
	{
		return (new this("DELETE", url, data, config)).getPromise();
	}

	static patch(url, data, config)
	{
		return (new this("PATCH", url, data, config)).getPromise();
	}
}
